import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FeederService } from '../../services/feeder.service';
import * as _ from 'lodash';
import { CustomDateComponent } from '../../reports/customdate/custom-date.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { FeederReportsComponent } from '../feeder-reports/feeder-reports.component';
import { FeederpopupComponent } from '../feederpopup/feederpopup.component';
import {FeedermanagerComponent} from '../feedermanager/feedermanager.component'
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { ManagerComponent } from '../manager/manager.component';

@Component({
  selector: 'app-feederdashboard',
  templateUrl: './feederdashboard.component.html',
  styleUrls: ['./feederdashboard.component.scss']
})
export class FeederdashboardComponent implements OnInit {

  @ViewChild('individual_graph', { static: true }) individual_graph: ElementRef;


  currentUserData = JSON.parse(localStorage.getItem('userData'));
  roleid = this.currentUserData.roleid;
  userid = this.currentUserData.userid;
  feederOptions = [];
  selectedFeeder: any;
  displayedOptions = [];
  displayedFeeder: any;
  timeOptions: any = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
  timeFilter: any = 'Today';
  allTileData;
  paramAlertStatus = {"overload":"0", "underload":"0", "criticalLoad":"0", "lugtemp":"0", "highVolt":"0", "lowVolt":"0", "IUnbalance":"0", "VUnbalance":"0"};
  date;
  feederData;
  customDate = {startDate: '', endDate: ''};
  isFeederData: boolean = false;
  individual_graph_g;
  chart_i;
  paramList = ['Current', 'Voltage', 'PF', 'Load', 'Current THD', 'Voltage THD', 'Humidity & Temp', 'LUG Temp'];
  selectedParam = this.paramList[0];



  constructor(private feederService: FeederService, private matDialog: MatDialog, private ngxLoader: NgxUiLoaderService,private router: Router) { }

  ngOnInit() {
    
    this.ngxLoader.startLoader("feeder");

    this.feederService.getFeeders({"userid": this.userid, "roleid":this.roleid}).subscribe((response:any) => {
      if(response.data.length > 0){
        this.feederOptions = [];
        this.displayedOptions = [];
        //console.log("Response >>>>>", response.data);
        response.data.forEach(element => {
          this.feederOptions.push(element.transformerid)
          this.displayedOptions.push(element.id + '[' + element.sitename + ']')
        });
        this.feederOptions.sort();
        this.displayedOptions.sort();
        //this.selectedFeeder = this.feederOptions[0];
        this.displayedFeeder = this.displayedOptions[0];
        console.log("feederOptions", this.feederOptions);
        console.log('displayedOptions', this.displayedOptions);

        this.getFeederTileData(this.feederOptions);
        this.getFeeerAlertParamStatus(this.feederOptions);
        this.getFeederData(this.displayedFeeder)
      }
    });
  }
  openManagerSettings() {
    let dialogRef;
    dialogRef = this.matDialog.open(ManagerComponent, {
      height: '70%',
      width: '40%',
    });
  }
  getFeederTileData(feederList: any){
    this.allTileData = null;
    this.feederService.getFeederTileData({"feederList": feederList}).subscribe((response:any) => {
      //console.log("RESPONSE FOR FEEDER", response)
      if(response.code== '1'){
        this.allTileData = response.data;
        console.log("tile data >>>>>>>>>", this.allTileData)
      }
      this.ngxLoader.stopLoader("feeder")
    });
  }

  getFeeerAlertParamStatus(feederList:any){
    this.paramAlertStatus = {"overload":"0", "underload":"0", "criticalLoad":"0", "lugtemp":"0", "highVolt":"0", "lowVolt":"0", "IUnbalance":"0", "VUnbalance":"0"};
    this.feederService.getFeederAlertParamStatus({"feederList": feederList}).subscribe((response:any) => {
      //console.log("Response for FEEDER", response);
      if(response.code == '1'){
        console.log("ALERT STATUS >>>>", response.data);
        for(var i=0;i<response.data.length; i++){
          if(response.data[i].paramName.toLowerCase() == 'overload'){
            this.paramAlertStatus.overload = response.data[i].p_count;
          } else if(response.data[i].paramName.toLowerCase() == "underload"){
            this.paramAlertStatus.underload = response.data[i].p_count;
          } else if(response.data[i].paramName.toLowerCase() == "criticalload"){
            this.paramAlertStatus.criticalLoad = response.data[i].p_count;
          } else if(response.data[i].paramName.toLowerCase() == "lugtemp"){
            this.paramAlertStatus.lugtemp = response.data[i].p_count;
          } else if(response.data[i].paramName.toLowerCase() == "highvoltage"){
            this.paramAlertStatus.highVolt = response.data[i].p_count;
          } else if(response.data[i].paramName.toLowerCase() == "lowvoltage"){
            this.paramAlertStatus.lowVolt = response.data[i].p_count;
          } else if(response.data[i].paramName.toLowerCase() == "iunbalance"){
            this.paramAlertStatus.IUnbalance = response.data[i].p_count;
          } else if(response.data[i].paramName.toLowerCase() == "vunbalance"){
            this.paramAlertStatus.VUnbalance = response.data[i].p_count;
          } 
        }
        console.log("INDIVIDUAL STATUS>>>>>", this.paramAlertStatus);
      }
    });
  }

  getFeederData(feederid){
    this.ngxLoader.startLoader("feederChanger");
    feederid = _.cloneDeep(feederid).split('[')[0];
    this.date = [];
    this.feederData = [];

    console.log("DATE SELECETED", this.timeFilter);

    if(this.timeFilter.toLowerCase() == 'custom'){
      //CODE FOR CUSTOM API
      this.feederService.getFeederData({"feederid":feederid, "duration": {"type": this.timeFilter, "startDate": this.customDate.startDate, "endDate": this.customDate.endDate}}).subscribe((response: any) => {
        console.log("FEEDER DATA >>>>>", response);
        if(response.data.length > 0){
          this.graphIndividual();
          this.isFeederData = true;
          response.data.forEach(element => {
            this.date.push(element.DATE)
            this.feederData.push(JSON.parse(element.readings));
          });
          console.log("DATE AND READINGS >>>>", this.date, this.feederData);
          //this.selectedParam = this.paramList[0];
          //this.updateCurrent();
          this.parameterSelection(this.selectedParam);
          this.ngxLoader.stopLoader("feederChanger");
        } else {
          this.ngxLoader.stopLoader("feederChanger");
          this.isFeederData = false;
          this.date = null;
          this.feederData = null;
          this.chart_i.destroy();
          console.log("THERE IS NO DATA FOR THIS SWITCH FOR SELECTED TIME")
        }
        
      });
    } else {
      //CODE FOR REST OF DURATIONS
      this.feederService.getFeederData({"feederid": feederid, "duration": {"type": this.timeFilter}}).subscribe((response:any) => {
        console.log("FEEDER DATA >>>>>", response)
        if(response.data.length > 0){
          this.graphIndividual();
          this.isFeederData = true;
          response.data.forEach(element => {
            this.date.push(element.DATE)
            this.feederData.push(JSON.parse(element.readings));
          });
          console.log("DATE AND READINGS >>>>", this.date, this.feederData);
          //this.selectedParam = this.paramList[0];
          //this.updateCurrent();

          this.parameterSelection(this.selectedParam);

        } else {
          this.ngxLoader.stopLoader("feederChanger");
          this.isFeederData = false;
          this.date = null;
          this.feederData = null;
          this.chart_i.destroy();
          console.log("THERE IS NO DATA FOR THIS SWITCH FOR SELECTED TIME")
        }
        this.ngxLoader.stopLoader("feederChanger");
      });
    }
  }

  dateSelection(){
    console.log("TIME Filler ", this.timeFilter);

    if(this.timeFilter.toLowerCase() == 'custom'){
      //const dialogConfig = new MatDialogConfig();
      let dialogRef = this.matDialog.open(CustomDateComponent, {
        autoFocus: false,
        height: '350px', width: '450px'
      });
      dialogRef.afterClosed().subscribe(value => {
        console.log("VALUE", value);
        this.customDate.startDate = value.startDate;
        this.customDate.endDate = value.endDate; 

        this.getFeederData(this.displayedFeeder);
      });
    } else {
      this.getFeederData(this.displayedFeeder);
    }
  }

  parameterSelection(param: string){
    this.ngxLoader.startLoader("feederChanger");
    this.selectedParam = param;

    if(this.selectedParam.toLowerCase() == 'current'){
      console.log('IN CURRENT');
      this.updateCurrent();
    } else if(this.selectedParam.toLowerCase() == 'voltage'){
      console.log('IN VOLTAGE');
      this.updateVoltage();
    } else if(this.selectedParam.toLowerCase() == 'pf') {
      console.log('IN PF');
      this.updatePF();
    } else if(this.selectedParam.toLowerCase()=='load'){
      console.log('IN LOAD');
      this.updateLoad();
    } else if(this.selectedParam.toLowerCase() == 'current thd'){
      console.log('IN CURRENT THD');
      this.updateCurrentTHD()
    } else if(this.selectedParam.toLowerCase() == 'voltage thd'){
      console.log('IN VOLTAGE THD');
      this.updateVoltageTHD();
    } else if(this.selectedParam.toLowerCase() == 'humidity & temp'){
      console.log('IN HUMIDITY & TEMP');
      this.updateHumidity();
    } else if(this.selectedParam.toLowerCase() == 'lug temp'){
      console.log('IN lug TEMP');
      this.updateLUG();
    }
    this.ngxLoader.stopLoader("feederChanger");
  }

  graphIndividual(){
    const options = {
      series: [{
        name: "Value",
        data: [0]
      }],
      chart: {
        type: 'line',
        height: "100%",
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width:4
      },
      /*title: {
        text: 'Individual Meter Graph Data',
        style: {
              color: "black",
              fontWeight: 'bold'
            },
        align: 'left',
       
      },*/
      xaxis: {
        type: 'DateTime',
        tickAmount: 3,
        tickPlacement: 'between',
        intervalType: 'Hours',
        labels: {
          show: true,
          style: {
            colors: 'black',
            fontWeight: 'bold'
          },
          rotate: 0,
        }
  
      },
      yaxis: {
        labels: {
          style: {
            colors: 'black'
          }
        }
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left'
      }
    };
    this.chart_i = new ApexCharts(this.individual_graph.nativeElement, options);
    this.chart_i.render();
  }

  updateCurrent(){
    if(this.feederData){
      let I1 = this.feederData.map((result) => (result.L1));
      let I2 = this.feederData.map((result) => (result.L2));
      let I3 = this.feederData.map((result) => (result.L3));
      this.chart_i.updateOptions({
        series:[{
          name: 'L1',
          data: I1,
          type: 'line',
          color: '#FF0000'
        },
        {
          name: 'L2',
          data: I2,
          type: 'line',
          color: '#0000FF'
        },
        {
          name: 'L3',
          data: I3,
          type: 'line',
          color: '#FFFF00'
        }],
        xaxis: {
          categories: this.date
        },
        title: {
          text: 'Current',
          align: 'center',
        }
      });
    }
  }

  updateVoltage(){
    if(Array.isArray(this.feederData) && this.feederData.length > 0){
      let V1 = this.feederData.map((result) => (result.R_Ph_N));
      let V2 = this.feederData.map((result) => (result.Y_Ph_N));
      let V3 = this.feederData.map((result) => (result.B_Ph_N));
      let avgVolt = this.feederData.map((result) => (result.Average_Voltage));
      console.log("VOLTAGE 3", V1, V2, V3);

      this.chart_i.updateOptions({
        series:[{
          name: 'R_Ph_N',
          data: V1,
          type: 'line',
          color: '#FF0000'
        },
        {
          name: 'Y_Ph_N',
          data: V2,
          type: 'line',
          color: '#0000FF'
        },
        {
          name: 'B_Ph_N',
          data: V3,
          type: 'line',
          color: '#FFFF00'
        },
        {
          name: 'Average Voltage',
          data: avgVolt,
          type: 'line',
          color: '#008000'
        }],
        xaxis: {
          categories: this.date
        },
        title: {
          text: 'Voltage',
          align: 'center',
        }
      });
    }
  }

  updatePF(){
    if(Array.isArray(this.feederData) && this.feederData.length > 0){
      let r_pf =  this.feederData.map((result) => (result.R_Power_Factor));
      let y_pf =  this.feederData.map((result) => (result.Y_Power_Factor));
      let b_pf =  this.feederData.map((result) => (result.B_Power_Factor));
      let avg_pf =  this.feederData.map((result) => (result.Avg_Power_Factor));

      this.chart_i.updateOptions({
        series:[{
          name: 'R_Power_Factor',
          data: r_pf,
          type: 'line',
          color: '#FF0000'
        },
        {
          name: 'Y_Power_Factor',
          data: b_pf,
          type: 'line',
          color: '#0000FF'
        },
        {
          name: 'B_Power_Factor',
          data: y_pf,
          type: 'line',
          color: '#FFFF00'
        },
        {
          name: 'Avg_Power_Factor',
          data: avg_pf,
          type: 'line',
          color: '#008000'
        }],
        xaxis: {
          categories: this.date
        },
        title: {
          text: 'PF',
          align: 'center',
        }
      });
    }
  }

  updateLoad(){
    if(Array.isArray(this.feederData) && this.feederData.length > 0){
      let load = this.feederData.map((result) => (result.load));

      this.chart_i.updateOptions({
        series:[{
          name: 'Load',
          data: load,
          type: 'line',
          color: '#008000'
        }],
        xaxis: {
          categories: this.date
        },
        title: {
          text: 'Load (%)',
          align: 'center'
        }
      });
    }
  }

  updateCurrentTHD(){
    if(Array.isArray(this.feederData) && this.feederData.length > 0){
      let ir_Thd = this.feederData.map((result) => (result.IR_THD));
      let ib_Thd = this.feederData.map((result) => (result.IY_THD));
      let iy_Thd = this.feederData.map((result) => (result.IB_THD));

      this.chart_i.updateOptions({
        series: [{
          name: 'R Phase THD',
          data: ir_Thd,
          type: 'line',
          color: '#FF0000'
        },
        {
          name: 'Y Phase THD',
          data: iy_Thd,
          type: 'line',
          color: '#FFFF00'
        },
        {
          name: 'B Phase THD',
          data: ib_Thd,
          type: 'line',
          color: '#0000FF'
        }],
        xaxis: {
          categories: this.date
        },
        title: {
          text: 'Current THD',
          align: 'center'
        }
      })
    }
  }

  updateVoltageTHD(){
    if(Array.isArray(this.feederData) && this.feederData.length > 0){
      let vr_Thd = this.feederData.map((result) => (result.VR_THD));
      let vb_Thd = this.feederData.map((result) => (result.VY_THD));
      let vy_Thd = this.feederData.map((result) => (result.VB_THD));

      this.chart_i.updateOptions({
        series: [{
          name: 'R Phase THD',
          data: vr_Thd,
          type: 'line',
          color: '#FF0000'
        },
        {
          name: 'B Phase THD',
          data: vy_Thd,
          type: 'line',
          color: '#FFFF00'
        },
        {
          name: 'B Phase THD',
          data: vb_Thd,
          type: 'line',
          color: '#0000FF'
        }],
        xaxis: {
          categories: this.date
        },
        title: {
          text: 'Voltage THD',
          align: 'center'
        }
      });
    }
  }

  updateHumidity(){
    if(Array.isArray(this.feederData) && this.feederData.length > 0){
      let humidity = this.feederData.map((result) => (result.Humidity));
      let temp =  this.feederData.map((result) => (result.Ambient_Temperature));

      this.chart_i.updateOptions({
        series: [{
          name: 'Humitidy',
          type: 'line',
          data: humidity,
          color: '#FFA500'
        }, 
        {
          name: 'Ambient_Temperature',
          type: 'line',
          data: temp,
          color: '#00FF00'
        }],
        xaxis: {
          categories: this.date
        },
        title : {
          text: 'Humidity and Temperature',
          align: 'center'
        }
      });
    }
  }

  updateLUG(){
    if(Array.isArray(this.feederData) && this.feederData.length > 0){
      let LTSeries = [];
      for (let i = 1; i <= 12; i++) {
        LTSeries.push({
            name: `LUG Temp ${i}`,
            data: this.feederData.map((result) => result[`LT_${i}`]),
            type: 'line',
            // Assign different colors if needed, here are some example colors:
            color: ['#FF0000', '#FFFF00', '#0000FF', '#00FF00', '#FF00FF', '#00FFFF', '#FFA500', '#800080', '#008000', '#FFC0CB', '#800000', '#808000'][i - 1] 
        });
    }
    
    this.chart_i.updateOptions({
        series: LTSeries,
        xaxis: {
            categories: this.date
        },
        title: {
            text: 'LUG TEMP',
            align: 'center'
        },
        stroke:{
          width:2
        }
    });

    }
  }

  openAlertReport(){
    var feederID = _.cloneDeep(this.displayedFeeder).split('[')[0]
    console.log("Displayed Feeder", feederID);
    let dialogRef = this.matDialog.open(FeederReportsComponent, {
      height: '70%',
      width: '75%',
      data: {"selectedFeeder": feederID, "feederOptions": this.feederOptions, 'displayedOptions':this.displayedOptions, 'displayedFeeder':this.displayedFeeder, 'selectedDuration': this.timeFilter, 'timeOptions': this.timeOptions, 'startDate': this.customDate.startDate, 'endDate': this.customDate.endDate, 'type':'alert'}
    });
  }

  openGatewayReport(){
    var feederID = _.cloneDeep(this.displayedFeeder).split('[')[0]
    console.log("Displayed Feeder", feederID);
    let dialogRef = this.matDialog.open(FeederReportsComponent, {
      height: '90%',
      width: '95%',
      data: {"selectedFeeder": feederID, "feederOptions": this.feederOptions, "displayedOptions":this.displayedOptions, "displayedFeeder": this.displayedFeeder, "selectedDuration":this.timeFilter, "timeOptions": this.timeOptions, "startDate":this.customDate.startDate, "endDate": this.customDate.endDate, "type":"gateway"}
    });
  }

  popupTable(state, selected){
    let dialogRef;
    dialogRef = this.matDialog.open(FeederpopupComponent, {
      height: '55%',
      width: '55%',
      data: {'state': state, 'selected': selected, 'feederOptions': this.feederOptions}
    });
  }
}
